import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FlagSeverity } from '../../data/screening-results.model';

const SEVERITY_LABEL: Record<FlagSeverity, string> = {
  high: 'High severity',
  medium: 'Medium severity',
  low: 'Low severity',
  unrated: 'Unrated',
};

/**
 * Tint + dark text rather than the prototype's white-on-solid: white on `#E67514` is 3.1:1 and on
 * `#C9A200` is 2.0:1, both of which fail AA at the 10.5px this renders at.
 */
const SEVERITY_CLASS: Record<FlagSeverity, string> = {
  high: 'bg-red-50 text-red-700 dark:bg-red-400/10 dark:text-red-400',
  medium: 'bg-amber-50 text-amber-700 dark:bg-amber-400/10 dark:text-amber-300',
  low: 'bg-yellow-50 text-yellow-700 dark:bg-yellow-400/10 dark:text-yellow-300',
  unrated: 'bg-muted text-muted-foreground',
};

@Component({
  selector: 'scr-severity-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="inline-flex items-center rounded-full px-2.5 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.05em]"
      [class]="toneClass()">
      {{ label() }}
    </span>
  `,
})
export class SeverityPill {
  readonly severity = input.required<FlagSeverity>();

  readonly label = computed(() => SEVERITY_LABEL[this.severity()]);
  readonly toneClass = computed(() => SEVERITY_CLASS[this.severity()]);
}
